import tw from "twin.macro";

export default function FormPanel({ children, panelCss = tw`rounded-xl bg-form-panel p-4`, className }) {
    return (
        <div css={panelCss} className={className}>
            {children}
        </div>
    );
}
